import { render, staticRenderFns } from "./b-ticket-location-info.vue?vue&type=template&id=1ec4e667&scoped=true"
import script from "./b-ticket-location-info.vue?vue&type=script&lang=ts"
export * from "./b-ticket-location-info.vue?vue&type=script&lang=ts"
import style0 from "./b-ticket-location-info.vue?vue&type=style&index=0&id=1ec4e667&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec4e667",
  null
  
)

export default component.exports